'use client';

import React from 'react';
import { Button } from "@/app/components/ui/button"
import { useRouter } from 'next/navigation';
import Link from 'next/link';

interface TermsOfServiceProps {
  onClose?: () => void;
}

export default function TermsOfService({ onClose }: TermsOfServiceProps) {
  const router = useRouter();
  const handleClose = () => {
    if (onClose) {
      onClose();
    } else {
      router.back();
    }
  };

  return (
    <div className="min-h-screen bg-white pt-20">
      {/* Header with close button */}
      <div className="bg-[#3D669D] py-4 px-4">
        <div className="max-w-4xl mx-auto flex justify-between items-center">
          <h1 className="text-2xl font-bold text-white">Terms of Service</h1>
          <Button
            onClick={handleClose}
            size="sm"
            className="bg-white text-[#3D669D] hover:bg-gray-100 font-semibold"
          >
            Close
          </Button>
        </div>
      </div>
      
      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 py-8">
        <div className="space-y-6">
          <section className="bg-white border border-gray-200 p-6 rounded-lg shadow-sm">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">1. Acceptance of Terms</h2>
            <p className="text-gray-700 leading-relaxed">
              By accessing and using westvirginiawire.com (&quot;the Service&quot;), you accept and agree to be bound by the terms and conditions of this agreement.
            </p>
          </section>

          <section className="bg-white border border-gray-200 p-6 rounded-lg shadow-sm">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">2. Description of Service</h2>
            <p className="text-gray-700 leading-relaxed">
              West Virginia Wire provides news and information services about West Virginia, including but not limited to local news coverage, community updates, and regional insights.
            </p>
          </section>

          <section className="bg-white border border-gray-200 p-6 rounded-lg shadow-sm">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">3. User Conduct</h2>
            <p className="text-gray-700 leading-relaxed">
              Users agree to use the Service in compliance with all applicable laws and regulations. Users shall not engage in any activity that interferes with or disrupts the Service.
            </p>
          </section>

          <section className="bg-white border border-gray-200 p-6 rounded-lg shadow-sm">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">4. Intellectual Property</h2>
            <p className="text-gray-700 leading-relaxed">
              All content, features, and functionality of the Service are owned by West Virginia Wire and are protected by international copyright, trademark, and other intellectual property laws.
            </p>
          </section>

          <section className="bg-white border border-gray-200 p-6 rounded-lg shadow-sm">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">5. Limitation of Liability</h2>
            <p className="text-gray-700 leading-relaxed">
              West Virginia Wire shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of the Service.
            </p>
          </section>

          <section className="bg-white border border-gray-200 p-6 rounded-lg shadow-sm">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">6. Changes to Terms</h2>
            <p className="text-gray-700 leading-relaxed">
              West Virginia Wire reserves the right to modify these terms at any time. Users will be notified of any changes by posting the new Terms of Service on this page.
            </p>
          </section>

          <section className="bg-white border border-gray-200 p-6 rounded-lg shadow-sm">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">7. Contact</h2>
            <p className="text-gray-700 leading-relaxed">
              For any questions about these Terms, please contact us through the provided contact methods on our website.
            </p>
          </section>
        </div>
        
        {/* Footer with back link */}
        <div className="mt-8 pt-6 border-t border-gray-200 text-center">
          <Link 
            href="/" 
            className="text-[#3D669D] hover:text-blue-700 font-semibold"
          >
            ← Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
}
